<select
    [(ngModel)]="selectedTitle"
    required
    (blur)="onTouch()"
>
    <option
        [ngValue]="null"
        disabled
    >
        {{ 'Anrede' | formLabel: true : 'select' }}
    </option>
    @for (title of titles$() | async; track title) {
        <option [ngValue]="title">{{ title.description }}</option>
    }
</select>
